import React, { useMemo } from "react";
import GaugeChart from "react-gauge-chart";

const Top5Charts = ({ avgUtil,noOfChair, conditions, type }) => {
  const percentage = useMemo(() => {
    if(type === 1){
      if (
        avgUtil.toFixed(0) >= conditions["Good"]["Min"] &&
        avgUtil.toFixed(0) <= conditions["Good"]["Max"]
      ) {
        return 0.8;
      } else if (
        avgUtil.toFixed(0) >= conditions["Moderate"]["Min"] &&
        avgUtil.toFixed(0) <= conditions["Moderate"]["Max"]
      ) {
        return 0.5;
      } else if (
        avgUtil.toFixed(0) == conditions["Poor"]["Min"] ||
        avgUtil.toFixed(0) >= conditions["Poor"]["Max"]
      ) {
        return 0.2;
      } else return 0.2;
    }else if(type === 2){
      if (
       ( avgUtil/noOfChair *100).toFixed(0) >= conditions["Good"]["Min"] &&
       ( avgUtil/noOfChair *100).toFixed(0) <= conditions["Good"]["Max"]
      ) {
        return 0.8;
      } else if (
       ( avgUtil/noOfChair *100).toFixed(0) > conditions["Moderate"]["Min"] &&
       ( avgUtil/noOfChair *100).toFixed(0) < conditions["Moderate"]["Max"]
      ) {
        return 0.5;
      } else if (
       ( avgUtil/noOfChair *100).toFixed(0) >= conditions["Poor"]["Min"] &&
       ( avgUtil/noOfChair *100).toFixed(0) <= conditions["Poor"]["Max"]
      ) {
        return 0.2;
      } else return 0.2;
    }else if (type===3 || type === 4){
      if (
        ( avgUtil.toFixed(0)) >= conditions["Good"]["Min"] &&
        ( avgUtil.toFixed(0)) <= conditions["Good"]["Max"]
       ) {
         return 0.8;
       } else if (
        ( avgUtil.toFixed(0)) > conditions["Moderate"]["Min"] &&
        ( avgUtil.toFixed(0)) < conditions["Moderate"]["Max"]
       ) {
         return 0.5;
       } else if (
        ( avgUtil.toFixed(0)) >= conditions["Poor"]["Min"] ||
        ( avgUtil.toFixed(0)) <= conditions["Poor"]["Max"]
       ) {
         return 0.2;
       } else return 0.2;
    }
 
  }, [avgUtil, type]);

  return (
    <div className="d-flex flex-column">
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        colors={["#f00", "#ffff00", "lawngreen"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={percentage} // Max 100
        hideText="true"
        style={{ width: "50px" }}
        className="dashboard-health-title"
      />
      <span style={{ fontSize: "14px" }}>
        {avgUtil !== "N/A" && (avgUtil > 100 ? 100 : avgUtil.toFixed(0))}
        {(type === 3 || type === 4) && `%`}
      </span>
    </div>
  );
};

export default Top5Charts;
